<ng-container *ngIf="orgLogoURL.length > 0 || !fallbackLogo">
    <div class="d-flex align-items-start justify-content-between">
        <div class="logo-container mr-3"
             [class.mb-3]="fallbackLogo">
            <ng-template #fallbackOrganizationLogo>
                <img alt="{{'Organization Logo'}}"
                     class="img img-fluid logo"
                     [style.height.px]="48"
                     src="/assets/images/payhoa/marketing/logo.svg"/>
            </ng-template>
            <ng-container *ngIf="orgLogoURL.length > 0; else fallbackOrganizationLogo">
                <img alt="{{'Organization Logo'}}"
                     class="img img-fluid logo"
                     [style.max-width.px]="225"
                     src="{{orgLogoURL}}"/>
            </ng-container>
        </div>

        <div *ngIf="!isReplacingLogo"
             class="mat-button-group mr-0">
            <app-button type="primary-outline"
                        [buttonClasses]="['rounded', orgLogoURL.length > 0 ? 'mr-3' : 'mr-0']"
                        (onClick)="isReplacingLogo = true">{{'Change Logo'}}</app-button>
            <app-button *ngIf="orgLogoURL.length > 0"
                        type="warn-outline"
                        icon="delete"
                        [buttonClasses]="['rounded', 'mr-0', 'px-1']"
                        (onClick)="resetOrgLogo()"></app-button>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="(!orgLogoURL.length && fallbackLogo) || isReplacingLogo">
    <div class="d-flex align-items-center">
        <mat-spinner class="mr-2"
                     [diameter]="18"
                     [strokeWidth]="2"
                     [hidden]="!imageEditor.uploading"></mat-spinner>
        <label>{{'Add Logo'}}</label>
    </div>
    <div class="d-flex flex-column mb-3">
        <lf-image-editor #imageEditor
                         [id]="'organization-logo-uploader'"
                         [height]="94"
                         [width]="225"
                         (onUpload)="onOrgLogoUpload($event)"></lf-image-editor>
        <app-button *ngIf="isReplacingLogo && (!imageEditor || !imageEditor.fileInput)"
                    [buttonClasses]="['mt-3']"
                    (click)="isReplacingLogo = false">{{'Cancel'}}</app-button>
    </div>
</ng-container>
